var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
function _typeof(o) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof(o);
}
__name(_typeof, "_typeof");
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
}
__name(_defineProperty, "_defineProperty");
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
__name(_toPropertyKey, "_toPropertyKey");
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
__name(_toPrimitive, "_toPrimitive");
import React from "react";
import classNames from "classnames";
import { filterItemCls, filterItemInlineCls, filterItemFadedCls, filterItemLabelWrapperCls, filterItemLabelCls, filterItemTextCls, filterItemContentCls } from "./Slider.less";
var FilterSliderItem = /* @__PURE__ */ __name(function FilterSliderItem2(_ref) {
  var children = _ref.children, title = _ref.title, text = _ref.text, _ref$faded = _ref.faded, faded = _ref$faded === void 0 ? false : _ref$faded, className = _ref.className, _ref$inline = _ref.inline, inline = _ref$inline === void 0 ? false : _ref$inline;
  return /* @__PURE__ */ React.createElement("div", {
    className: classNames(!inline && filterItemCls, inline && filterItemInlineCls, _defineProperty({}, filterItemFadedCls, faded), className)
  }, /* @__PURE__ */ React.createElement("div", {
    className: filterItemLabelWrapperCls
  }, title ? /* @__PURE__ */ React.createElement("span", {
    className: filterItemLabelCls
  }, title) : null, text ? /* @__PURE__ */ React.createElement("span", {
    className: filterItemTextCls
  }, text) : null), /* @__PURE__ */ React.createElement("div", {
    className: filterItemContentCls
  }, children));
}, "FilterSliderItem");
export {
  FilterSliderItem
};
